// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5647) return "static/chunks/ca377847-425e65a62baac1bf.js";
	if (chunkId === 6640) return "static/chunks/6640-acc9ce40ea65a135.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"728":"f92686b43cfd634c","2571":"cb9ad4c5d861cf21","3565":"4d469edef354d201","8347":"0e975895359c73fb"}[chunkId] + ".js";
};